module.exports = __webpack_public_path__ + "static/media/gryphon_musee_logo.e45d9aa0.svg";